// Schéma interactif (desktop) : chaque entrée (pin + bouton textuel) ouvre une modal
// à l'emplacement de son bouton. Le contenu est cloné depuis le panneau d'accordéon
// correspondant (même source que le mobile). La navigation déplace la modal vers l'entrée.
export function initSchema() {
  const stage = document.querySelector(".c-questions__illu");
  const schema = document.querySelector(".c-schema");
  const modal = document.getElementById("schema-modal");
  if (!stage || !schema || !modal) return;

  const entries = [...schema.querySelectorAll(".c-schema__entry")];
  const panels = [...document.querySelectorAll(".c-accordion__panel")];
  if (!entries.length) return;

  const qEl = modal.querySelector(".c-modal__q");
  const bodyEl = modal.querySelector(".c-modal__body");
  const dots = modal.querySelector(".c-dots");
  const closeBtn = modal.querySelector(".c-modal__close");
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)");
  const EXIT_MS = 280; // doit couvrir la transition de fermeture (cf. _c-schema.scss)
  let current = -1;
  let lastTrigger = null;

  dots.innerHTML = entries
    .map(
      (_, i) =>
        `<button class="c-dots__dot" type="button" data-index="${i}" aria-label="Question ${i + 1}"></button>`,
    )
    .join("");
  const dotEls = [...dots.querySelectorAll(".c-dots__dot")];

  // Pose la modal près du bouton de l'entrée, en la gardant dans la scène
  const position = (i) => {
    const btn = entries[i].querySelector(".c-schema__btn");
    const sr = stage.getBoundingClientRect();
    const br = btn.getBoundingClientRect();
    const mr = modal.getBoundingClientRect();
    const margin = sr.width * 0.01;
    let left = br.left - sr.left;
    let top = br.top - sr.top;
    left = Math.max(margin, Math.min(left, sr.width - mr.width - margin));
    top = Math.max(margin, Math.min(top, sr.height - mr.height - margin));
    modal.style.left = `${(left / sr.width) * 100}%`;
    modal.style.top = `${(top / sr.height) * 100}%`;
  };

  const render = (i) => {
    const label = entries[i].querySelector(".c-schema__btn-label");
    qEl.textContent = label ? label.textContent : "";
    bodyEl.innerHTML = panels[i] ? panels[i].innerHTML : "";
    dotEls.forEach((d, j) =>
      j === i ? d.setAttribute("aria-current", "true") : d.removeAttribute("aria-current"),
    );
    entries.forEach((e, j) => e.classList.toggle("c-schema__entry--active", j === i));
  };

  const open = (i, trigger) => {
    if (trigger) lastTrigger = trigger;
    current = i;
    modal.hidden = false;
    render(i); // remplit le contenu → la taille est connue pour le positionnement
    schema.classList.add("c-schema--open");
    position(i);
    requestAnimationFrame(() => {
      position(i);
      modal.dataset.open = "true";
    });
    closeBtn.focus();
  };

  const close = () => {
    modal.removeAttribute("data-open");
    delete modal.dataset.dismissHover;
    schema.classList.remove("c-schema--open");
    entries.forEach((e) => e.classList.remove("c-schema__entry--active"));
    if (reduce.matches) modal.hidden = true;
    else setTimeout(() => (modal.hidden = true), EXIT_MS);
    current = -1;
    if (lastTrigger) lastTrigger.focus();
  };

  // Navigation : ferme la modal (fondu sortant) puis la ré-ouvre à l'emplacement de
  // l'entrée cible (fondu entrant). Pas de glissement/morphing entre les deux positions.
  const goTo = (i) => {
    const n = entries.length;
    const target = ((i % n) + n) % n;
    if (reduce.matches) {
      open(target); // pas d'animation : bascule directe
      return;
    }
    modal.removeAttribute("data-open"); // fondu sortant sur place
    setTimeout(() => open(target), EXIT_MS); // ré-ouverture une fois la modal disparue
  };

  // Déclencheurs : le pin ET le bouton textuel de chaque entrée
  entries.forEach((entry, i) =>
    entry.querySelectorAll(".c-schema__pin, .c-schema__btn").forEach((tr) =>
      tr.addEventListener("click", () => open(i, tr)),
    ),
  );
  // Fermeture : un clic n'importe où sur la carte (hors nav) ferme la modal — la croix
  // reste le repère visuel. La nav (préc./suiv./points) garde ses propres actions ;
  // les liens éventuels du corps et les sélections de texte ne déclenchent pas la fermeture.
  const inNav = (el) => el.closest && el.closest(".c-modal__nav");
  modal.addEventListener("click", (e) => {
    if (modal.dataset.open !== "true") return;
    if (inNav(e.target) || e.target.closest("a")) return;
    if (window.getSelection().toString()) return;
    close();
  });

  // Rollover mutualisé : survoler la carte (hors nav) allume le bouton de fermeture et
  // passe le curseur en « pointer », signalant que toute la zone est cliquable.
  modal.addEventListener("pointerover", (e) => {
    if (modal.dataset.open !== "true") return;
    if (inNav(e.target)) delete modal.dataset.dismissHover;
    else modal.dataset.dismissHover = "true";
  });
  modal.addEventListener("pointerout", (e) => {
    if (!modal.contains(e.relatedTarget)) delete modal.dataset.dismissHover;
  });

  modal.querySelector(".c-modal__prev").addEventListener("click", () => goTo(current - 1));
  modal.querySelector(".c-modal__next").addEventListener("click", () => goTo(current + 1));
  dots.addEventListener("click", (e) => {
    const d = e.target.closest(".c-dots__dot");
    if (d) goTo(Number(d.dataset.index));
  });

  document.addEventListener("keydown", (e) => {
    if (modal.dataset.open !== "true") return;
    if (e.key === "Escape") close();
    else if (e.key === "ArrowLeft") goTo(current - 1);
    else if (e.key === "ArrowRight") goTo(current + 1);
  });

  window.addEventListener("resize", () => {
    if (modal.dataset.open === "true" && current >= 0) position(current);
  });
}
